export const iconFontAwesomeEnergyBatteryHalf = (
	<i className="fa-solid fa-battery-half"></i>
);
